export default __webpack_public_path__ + "static/media/buy_gmx.618eb538.svg";